module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_5.097e8c5e.png";